import { lazy } from 'react';

import { PageSuspense } from 'src/components';


const SystemSettingUsersPage = lazy(() => import('../views/list/SystemSettingUsersPage'));

export function SystemSettingUsersPageLazy() {
	return (
		<PageSuspense>
			<SystemSettingUsersPage />
		</PageSuspense>
	);
}
